const ENDPOINT_I18NS = '/i18ns'
const ENDPOINT_DISCIPLINES = '/disciplines'
const ENDPOINT_PRACTICE_TRENDS = '/practicetrends'
const ENDPOINT_PRACTICE_STYLES = '/secure/practicestyles'
const ENDPOINT_COURSE_TYPES = '/coursetypes'
const ENDPOINT_LEVELS = '/levels'
const ENDPOINT_QUALITIES = '/qualities'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchI18ns({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(ENDPOINT_I18NS)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchDisciplines({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_DISCIPLINES}?sort=weight&order=asc&status=1`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchPracticeTrends({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_PRACTICE_TRENDS}?sort=weight&order=asc&status=1`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchPracticeStyles({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_PRACTICE_STYLES}?sort=translations&order=asc&status=1`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCourseTypes({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_COURSE_TYPES}?sort=weight&order=asc&status=1`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchLevels({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_LEVELS}?sort=weight&order=asc&status=1`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchQualities({ commit, rootState }) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_QUALITIES}?sort=weight&order=asc&status=1`
      )
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
